import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getHomepageBlockPrimaryStyleOptions } from "../constants";
import placeholderImage from "./homepage_block_1_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock1",
  props: {
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Lead with confidence. Grow with community.",
        }),
        createPBlock({
          text: "Your roadmap to leadership success: Expert coaching, a powerful peer network, and a system for sustained career growth. Get clarity, confidence, and support—starting today.",
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "33rem",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Join the Community",
          href: "#",
        }),
        createButtonBlock({
          text: "Book a Consultation",
          buttonType: "secondaryButton",
          href: "#",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getHomepageBlockPrimaryStyleOptions(),
      },
    },
  },
  meta: {
    name: "HomepageBlock1",
    isHidden: false,
  },
};
